// import { gql } from "@apollo/client";
import { gql } from "@apollo/client"
// Fragments
const AUTH_FRAGMENTS = {
  currentUser: gql`
    fragment CurrentUserFrag on BaseUserType {
      id
      number
      username
      fullName
      email
      photo
      isSuperadmin
      permissions
      groups {
        id
        name
      }
      currentDepartment {
        id
        demandWhatsappApproval
        kiteReferenceId
        pricingDoneOn
        gateEntryRequired
        defaultPerUnit {
          id
          name
          capacity
          selfWeight
          capacityUnit {
            id
            name
            codename
          }
        }
        name
        photo
        metadata
        invoiceType
        controlPricing
        hasDynamicStock
        optionalPricing
        qcSubscription
        defaultTraderVarieties {
          id
          name
          commodity {
            id
            name
          }
        }
        isB2c
        access {
          id
          codename
        }
        generatePoAfterInward
        companies {
          id
          name
        }
      }
      departments {
        id
        name
        photo
      }
    }
  `,
}
// Queries
export const ME = gql`
  query me {
    me {
      permissions
      distributionCentres {
        id
        name
        pointOfContacts {
          id
          name: fullName
          number
          groups {
            id
            name
          }
        }
        address {
          id
          village
          taluka
          district
          address
        }
        pickupSlots {
          id
          name
          fromTime
          toTime
        }
      }
      user {
        ...CurrentUserFrag
      }
    }
  }
  ${AUTH_FRAGMENTS.currentUser}
`

// Mutations
export const LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(
      username: $username
      password: $password
      firebaseToken: "dashboard"
    ) {
      token
      me {
        ...CurrentUserFrag
      }
    }
  }
  ${AUTH_FRAGMENTS.currentUser}
`

export const CHANGE_CURRENT_DEPARTMENT = gql`
  mutation updateDepartment($department: Int!) {
    switchDepartment(department: $department) {
      user {
        ...CurrentUserFrag
      }
    }
  }
  ${AUTH_FRAGMENTS.currentUser}
`

export const CHANGE_PASSWORD = gql`
  mutation updatePassword($newPassword: String!) {
    changePassword(newPassword: $newPassword) {
      user {
        ...CurrentUserFrag
      }
    }
  }
  ${AUTH_FRAGMENTS.currentUser}
`

export const DAILY_OTP = gql`
  query dailyMasterOtp {
    dailyMasterOtp
  }
`
